import api from "./axios"; // axios déjà configuré avec baseURL

export const getModes = () => api.get("/modes");       
export const getModeById = (id) => api.get(`/modes/${id}`);

export const createMode = async (data) => {
  try {
    const res = await api.post("/modes", data);
    console.log("Mode de Paiement à créé :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la création :", ex.response ? ex.response.data : ex);
  }
};

export const updateMode = async (id, data) => {
  try {
    const res = await api.put(`/modes/${id}`, data);
    console.log("Le mode de paiement  mis à jour :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la mise à jour :", ex.response ? ex.response.data : ex);
  }
};

export const deleteMode = async (id) => {
  try {
    const res = await api.delete(`/modes/${id}`);
    console.log("le mode de paiement supprimé :", res.data);
    return res.data;
  } catch (ex) {
    console.error("Erreur lors de la suppression :", ex.response ? ex.response.data : ex);
  }
};
